<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "公告添加" : "公告编辑" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='500'
      >
        <template v-slot:content>
           <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="公告标题"  hide-details='auto' outlined :rules="required" v-model="form.title"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-select
                    :items="[{ text: '通知', value: 1 },{ text: '通报', value: 2 }]"
                    label="公告类型"
                    v-model="form.type"
                    hide-details='auto'
                    outlined
                    :rules="required"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                 <file-upload
                    label="附件信息"
                    outlined
                    prepend-icon=''
                    :bucket='bucket'
                    @on-files='onFileName'
                    :file-name='form.fileName'
                    multiple
                    hide-details='auto'
                  ></file-upload>
                </v-col>
              </v-row>


              <v-row>
                <v-col cols="12">
                 <v-radio-group v-model="form.setType" @change="form.setIds = []" hide-details='auto' row :rules="required">
                      <v-radio label="全公司" :value="1"></v-radio>
                      <v-radio label="指定部门" :value="2"></v-radio>
                      <v-radio label="指定员工" :value="3"></v-radio>
                    </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" v-if="form.setType === 2" class="pl-0">
                  <v-tree-select
                      ref='dept'
                      path='system/dept/tree'
                      v-model="form.setIds"
                      selection-type='independent'
                    />
                  </v-col>
                  <v-col cols="12" v-if="form.setType === 3">
                   <base-marerial-user-select label='人员选择' hide-details outlined :dense='false' v-model="form.setIds"></base-marerial-user-select>
                  </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-textarea
                    rows='5'
                    outlined
                    v-model="form.content"
                    :rules="required"
                    label="公告内容">
                    </v-textarea>
                </v-col>
              </v-row>

            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import FileUpload from '@/components/oss/Index.vue'
  import { save } from '@/api/notice/index.js'
  import VTreeSelect from '@/components/select/v-tree-select-multiple.vue'

  export default {
    name: 'NoticeEdit',
    components: {
      VTreeSelect,
      FileUpload
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        bucket: 'yd-notice',
        form: {
          id: '',
          type: 1,
          setType: 1,
          setIds: [],
          title: '',
          content: '',
          fileName: ''
        },
        defForm: {
          id: '',
          type: 1,
          setType: 1,
          setIds: [],
          title: '',
          content: '',
          fileName: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      onFileName (fileNames) {
       let fileName = ''
        fileNames.forEach(name => {
          fileName += `${this.bucket}/${name},`
        })
        this.form.fileName = fileName.substring(0, fileName.lastIndexOf(','))
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
